// @owners { team: patients }
import { type Brand } from '@alto/design-system';
import { isWebStaging } from './isWebStaging';

const auth0Domains: Record<Brand, Record<string, string>> = {
  fuzerx: {
    dev: 'login.dev.pharmacy.fuzehealth.com',
    stg: 'login.stg.pharmacy.fuzehealth.com',
    prod: 'login.prod.pharmacy.fuzehealth.com',
  },
};

const resolveEnv = (backendEnv: string): string => {
  if (isWebStaging({ backendEnv }) || backendEnv === 'staging') return 'stg';
  if (backendEnv === 'production') return 'prod';
  return 'dev';
};

export const getAuth0Domain = (backendEnv: string) => {
  // require lazily to avoid early React Native import. this fixed an issue where Jest failed to resolve getBrand()
  // which caused native tests to fail
  // eslint-disable-next-line @typescript-eslint/no-require-imports
  const { getBrand } = require('../../../../libs/design-system');
  const brand: Brand = getBrand();
  return auth0Domains[brand][resolveEnv(backendEnv)];
};

export const getAuth0ClientID = (backendEnv: string, ids: Record<Brand, Record<string, string>>) => {
  // eslint-disable-next-line @typescript-eslint/no-require-imports
  const { getBrand } = require('../../../../libs/design-system');
  const brand: Brand = getBrand();
  return ids[brand][resolveEnv(backendEnv)];
};
